import React from 'react';
import Grid from '@material-ui/core/Grid';
import FPButtonMenu from 'UI/components/molecules/FPButtonMenu';
import SkeletonWrapper from 'UI/components/organisms/inventoryProfiles/SkeletonWrapper';

const ActionsBar = ({ isLoading, buttons, actionsBar, additionalHeaderActions, menuItems }) => {
  return (
    <SkeletonWrapper
      gridProps={{ justifyContent: 'flex-end' }}
      loading={isLoading}
      skeletonsCount={1}
      skeletonProps={buttons}
      spacing={2}
    >
      {actionsBar || (
        <>
          {additionalHeaderActions}
          <Grid item>
            <FPButtonMenu
              isIconButton
              tooltipProps={{ title: 'Menu Options' }}
              variant="outlinePrimary"
              menuItems={menuItems}
            />
          </Grid>
        </>
      )}
    </SkeletonWrapper>
  );
};

export default ActionsBar;
